<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 5.15625C3 4.80078 3.27344 4.5 3.65625 4.5H6.9375C7.40234 4.5 7.86719 4.74609 8.14062 5.12891L11.1211 9.01172C11.1484 9.06641 11.2305 9.09375 11.2852 9.09375H14.7578L13.6914 8.02734C13.418 7.78125 13.418 7.37109 13.6914 7.09766C13.9375 6.85156 14.3477 6.85156 14.5938 7.09766L16.7812 9.28516C17.0547 9.55859 17.0547 9.96875 16.7812 10.2148L14.5938 12.4023C14.3477 12.6758 13.9375 12.6758 13.6914 12.4023C13.418 12.1562 13.418 11.7461 13.6914 11.4727L14.7578 10.4062H11.2852C11.2305 10.4062 11.1484 10.4609 11.1211 10.5156L8.14062 14.3984C7.86719 14.7812 7.40234 15 6.9375 15H3.65625C3.27344 15 3 14.7266 3 14.3438C3 13.9883 3.27344 13.6875 3.65625 13.6875H6.9375C6.99219 13.6875 7.07422 13.6602 7.10156 13.6055L10.0273 9.75L7.10156 5.92188C7.07422 5.86719 6.99219 5.8125 6.9375 5.8125H3.65625C3.27344 5.8125 3 5.53906 3 5.15625Z"
      fill="currentColor"
    />
  </svg>
</template>
